import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, Guard } from '@digibricks/core';
import { Status } from '../../domain';
import { CreateFileStorageMethod } from './create-file-storage.input';
export var ImageSizeLimit = 4500000;
export var CreateFileStorageUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CreateFileStorageUseCase, _UseCase);

  var _super = _createSuper(CreateFileStorageUseCase);

  function CreateFileStorageUseCase(fileStorageRepository, externalFileStorageRepository) {
    var _this;

    _classCallCheck(this, CreateFileStorageUseCase);

    _this = _super.call(this);
    _this.fileStorageRepository = fileStorageRepository;
    _this.externalFileStorageRepository = externalFileStorageRepository;
    return _this;
  }

  _createClass(CreateFileStorageUseCase, [{
    key: "validateBaseInput",
    value: function validateBaseInput(input) {
      var file = input.file;
      var guardResult = Guard.againstNullOrUndefined(file, 'File Information Props');

      if (typeof file !== 'string' && !!file.type.match('image.*')) {
        var fileSizeResult = Guard.inRange(file.size, 0, ImageSizeLimit, 'Image size');

        if (!fileSizeResult.succeeded) {
          if (input.imageSizeMessageError) {
            return Result.fail(input.imageSizeMessageError);
          }

          return Result.fail(fileSizeResult.message);
        }
      }

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "getFileDtoFromFile",
    value: function getFileDtoFromFile(file) {
      var fileExtension = ".".concat(file.name.split('.').pop());
      return {
        fileExtension: fileExtension,
        fileSize: file.size,
        fileName: file.name.split('.')[0]
      };
    }
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var fileDto, newInput, createdFileStorageOrError, createdFileStorage, uploadedOrError, updatedStatusOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fileDto = this.getFileDtoFromFile(input.file);
                newInput = _objectSpread(_objectSpread({}, input), {}, {
                  fileDto: fileDto,
                  method: CreateFileStorageMethod.SIGNED_URL
                });
                _context.next = 4;
                return this.createFile(newInput);

              case 4:
                createdFileStorageOrError = _context.sent;

                if (!createdFileStorageOrError.isFailure) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", Result.fail(createdFileStorageOrError.error));

              case 7:
                createdFileStorage = createdFileStorageOrError.getValue();
                _context.next = 10;
                return this.externalFileStorageRepository.create(input.file, createdFileStorage.uploadUrl);

              case 10:
                uploadedOrError = _context.sent;

                if (!uploadedOrError.isFailure) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", Result.fail(uploadedOrError.error));

              case 13:
                _context.next = 15;
                return this.fileStorageRepository.updateFile({
                  id: createdFileStorage.id.toString(),
                  status: Status.uploaded
                });

              case 15:
                updatedStatusOrError = _context.sent;

                if (!updatedStatusOrError.isFailure) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", Result.fail(updatedStatusOrError.error));

              case 18:
                return _context.abrupt("return", Result.ok(createdFileStorage));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }]);

  return CreateFileStorageUseCase;
}(UseCase);